<template>
  <div>
    <el-row :gutter="20">
      <!-- 左侧：状态列表 -->
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="handleStateSelect('')"
              :class="{ 'selected': assetInventoryManageInfo.conditions.state === '' }">
              全部
            </li>
            <li v-for="(item, index) in assetInventoryManageInfo.states" :key="index"
              @click="handleStateSelect(item.statusCd)"
              :class="{ 'selected': assetInventoryManageInfo.conditions.state === item.statusCd }">
              {{ item.name }}
            </li>
          </ul>
        </el-card>
      </el-col>

      <!-- 右侧：查询条件和表格 -->
      <el-col :span="21">
        <!-- 查询条件 -->
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
          </div>
          <div class="">
            <el-form :inline="true" :model="assetInventoryManageInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-form-item>
                  <el-select v-model="assetInventoryManageInfo.conditions.shId" placeholder="请选择仓库" style="width:100%">
                    <el-option v-for="item in assetInventoryManageInfo.shopHouses" :key="item.shId" :label="item.shName"
                      :value="item.shId" />
                  </el-select>
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-form-item>
                  <el-input v-model="assetInventoryManageInfo.conditions.staffName" placeholder="请输入盘点人" />
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-model="assetInventoryManageInfo.conditions.queryStartTime"
                  type="date"
                  placeholder="开始时间"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-model="assetInventoryManageInfo.conditions.queryEndTime"
                  type="date"
                  placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="_queryAssetInventoryMethod">
                  <i class="el-icon-search"></i> 查询
                </el-button>
                <el-button @click="_resetAssetInventoryMethod">
                  <i class="el-icon-refresh"></i> 重置
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <!-- 资产盘点表格 -->
        <el-card class="margin-top-sm">
          <div slot="header" class="flex justify-between">
            <span>资产盘点</span>
            <el-button type="primary" size="small" style="float:right" @click="_openAddAssetInventoryModal">
              <i class="el-icon-plus"></i> 盘点
            </el-button>
          </div>
          <el-table :data="assetInventoryManageInfo.assetInventorys" border style="width:100%">
            <el-table-column prop="aiId" label="盘点单号" align="center" />
            <el-table-column prop="invTime" label="盘点时间" align="center" />
            <el-table-column prop="shName" label="盘点仓库" align="center" />
            <el-table-column prop="quantity" label="账面数量" align="center" />
            <el-table-column prop="invQuantity" label="盘点数量" align="center" />
            <el-table-column label="盘盈" align="center">
              <template slot-scope="scope">
                {{ _getInvProfit(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column label="盘亏" align="center">
              <template slot-scope="scope">
                {{ _getInvLoss(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column label="盘盈金额" align="center">
              <template slot-scope="scope">
                {{ _getInvProfitMoney(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column label="盘亏金额" align="center">
              <template slot-scope="scope">
                {{ _getInvLossMoney(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column prop="staffName" label="盘点人" align="center" />
            <el-table-column prop="stateName" label="状态" align="center" />
            <el-table-column label="操作" align="center" width="200">
              <template slot-scope="scope">
                <el-button v-if="scope.row.state == '4488'" size="mini"
                  @click="_openEditAssetInventoryModel(scope.row)">
                  修改
                </el-button>
                <el-button v-if="scope.row.state == '4488'" size="mini"
                  @click="_openDeleteAssetInventoryModel(scope.row)">
                  删除
                </el-button>
                <el-button size="mini" v-if="scope.row.state == '4488'" @click="_openInStockAssetInventoryModel(scope.row)">
                  入库
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
            layout="total, prev, pager, next" :total="assetInventoryManageInfo.total"
            style="margin-top:20px;text-align:right" />
        </el-card>
      </el-col>
    </el-row>

    <delete-asset-inventory ref="deleteAssetInventoryRef" />
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { queryAssetInventory, queryShopHouse } from '@/api/goods/assetInventoryApi'
import DeleteAssetInventory from '@/components/goods/deleteAssetInventory/deleteAssetInventory.vue'

export default {
  name: 'AssetInventoryManage',
  components: {
    DeleteAssetInventory
  },
  data() {
    return {
      assetInventoryManageInfo: {
        assetInventorys: [],
        shopHouses: [],
        total: 0,
        records: 1,
        moreCondition: false,
        aiId: '',
        states: [],
        conditions: {
          shId: '',
          staffName: '',
          state: '',
          shopId: '',
          queryStartTime: '',
          queryEndTime: '',
          page: 1,
          row: 10
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this.shopId = getShopId()
    this.assetInventoryManageInfo.conditions.shopId = this.shopId
    this._listShopHouses()
    this._listAssetInventorys(1, 10)
    this.getDictData()
  },
  methods: {
    async getDictData() {
      try {
        const { data } = await getDict('asset_inventory', 'state')
        this.assetInventoryManageInfo.states = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listAssetInventorys(val, this.pageSize)
    },
    async _listAssetInventorys(page, rows) {
      this.assetInventoryManageInfo.conditions.page = page
      this.assetInventoryManageInfo.conditions.row = rows
      try {
        const res = await queryAssetInventory(this.assetInventoryManageInfo.conditions)
        this.assetInventoryManageInfo.total = res.total
        this.assetInventoryManageInfo.records = res.records
        this.assetInventoryManageInfo.assetInventorys = res.data
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    _openAddAssetInventoryModal() {
      this.$router.push('/pages/goods/assetInventoryIn')
    },
    _openEditAssetInventoryModel(assetInventory) {
      this.$router.push(`/pages/goods/assetInventoryEdit?aiId=${assetInventory.aiId}`)
    },
    _openInStockAssetInventoryModel(assetInventory) {
      this.$router.push(`/pages/goods/assetInventoryInStock?aiId=${assetInventory.aiId}`)
    },
    _openDeleteAssetInventoryModel(assetInventory) {
      this.$refs.deleteAssetInventoryRef.open(assetInventory)
    },
    _queryAssetInventoryMethod() {
      this._listAssetInventorys(1, this.pageSize)
    },
    _resetAssetInventoryMethod() {
      this.assetInventoryManageInfo.conditions.shId = ""
      this.assetInventoryManageInfo.conditions.staffName = ""
      this.assetInventoryManageInfo.conditions.queryStartTime = ''
      this.assetInventoryManageInfo.conditions.queryEndTime = ''
      this._listAssetInventorys(1, this.pageSize)
    },
    handleStateSelect(state) {
      this.assetInventoryManageInfo.conditions.state = state
      this.currentPage = 1
      this._listAssetInventorys(1, this.pageSize)
    },
    _getInvLoss(assetInventory) {
      let _invLoss = parseInt(assetInventory.quantity) - parseInt(assetInventory.invQuantity)
      if (_invLoss > 0) {
        return _invLoss
      }
      return 0
    },
    _getInvProfit(assetInventory) {
      let _invProfit = parseInt(assetInventory.invQuantity) - parseInt(assetInventory.quantity)
      if (_invProfit > 0) {
        return _invProfit
      }
      return 0
    },
    _getInvLossMoney(assetInventory) {
      let _invLoss = parseInt(assetInventory.quantityMoney) - parseInt(assetInventory.invQuantityMoney)
      if (_invLoss > 0) {
        return _invLoss
      }
      return 0
    },
    _getInvProfitMoney(assetInventory) {
      let _invProfit = parseInt(assetInventory.invQuantityMoney) - parseInt(assetInventory.quantityMoney)
      if (_invProfit > 0) {
        return _invProfit
      }
      return 0
    },
    async _listShopHouses() {
      try {
        const res = await queryShopHouse({
          page: 1,
          row: 100,
          shopId: this.shopId
        })
        this.assetInventoryManageInfo.shopHouses = res.data || []
      } catch (error) {
        console.error('获取仓库列表失败:', error)
        this.$message.error('获取仓库列表失败')
      }
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.margin-top-sm {
  margin-top: 20px;
}
</style>